import PanelPage from "../../components/panel/panelPage";
import React, { useEffect, useState } from "react";
import PanelSubHeading from "../../components/panel/subHeading";
import PanelHeading from "../../components/panel/heading";
import PanelSearch from "../../components/filters/panelSearch";
import { FilterIcon } from "../../icons/filter";
import UserListTable from "../../components/users/userListTable";
import { useDispatch, useSelector } from "react-redux";
import { actions, RootState } from "../../state/reducer";
import { closeModal, openModal } from "../../state/modalSlice";
import UserFilterModal from "../../modals/filters/user";
import { UserFilters } from "../../forms/filters/user";
import UserCreateByAdminFormModal from "../../modals/users/createUserModal";
import { generateRandomString } from "../../utils";

const UserListPage = () => {

  const [searchValue, setSearchValue] = useState("")
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const rights = State.rights

  const search = (value: string) => {
    setSearchValue(value);
  }

  const handleOpenCreateModal = () => {
    dispatch(openModal({ component: UserCreateByAdminFormModal, context: {
      onSave: () => {
        setSearchValue("");
        dispatch(actions.selectItem(generateRandomString(3)))
      },
      closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
    }, }));
  }

  const handleOpenFilters = () => {
    dispatch(openModal({ component: UserFilterModal, context: {
      onApplyFilters: (filters: UserFilters) => {
        setSearchValue("");
        dispatch(actions.userRequestParams(filters))
      },
      closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
    }, }));
  }

  return (
    <PanelPage>
      <div className="panelColumnFull">
        <div className="profileWidget">
          <div className="flex between">
            <PanelSubHeading text="Пользователи" />
            <div className="flex">
              <div className="panelBtnContainer">
                <div className="btn panelActionBtn" style={{ display: "flex", whiteSpace: "nowrap" }}
                onClick={handleOpenCreateModal}>+ Добавить пользователя</div>
              </div>
              <div className="panelBtnContainer">
              <a href="/users/invites">
                <div className="btn panelActionBtn">+ Пригласить</div>
              </a>
            </div>
            </div>
          </div>
          <div className="flex between panelSearchContainer">
             <PanelSearch hint={"Поиск по ФИО"} onChange={search} />
             <div className="btn filterBtn" onClick={handleOpenFilters}>
                <FilterIcon width={20} height={20} />
             </div>
          </div>
          <UserListTable search={searchValue} />
        </div>
      </div>
    </PanelPage>
  );
};

export default UserListPage;
